import { render, staticRenderFns } from "./custom-panel.vue?vue&type=template&id=6edbed11&scoped=true"
import script from "./custom-panel.vue?vue&type=script&lang=js"
export * from "./custom-panel.vue?vue&type=script&lang=js"
import style0 from "./custom-panel.vue?vue&type=style&index=0&id=6edbed11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbed11",
  null
  
)

export default component.exports